<button
  nz-button
  type="button"
  nzType="primary"
  nzSize="small"
  (click)="openModal.set(true)"
>
  <span nz-icon nzType="bug" nzTheme="outline"></span>
  {{ 'home.encounterProblemLabel' | translate }}
</button>

<nz-modal
  nzCentered
  nzMaskClosable="false"
  [nzWidth]="600"
  [nzTitle]="'shared.reportIssue.title' | translate"
  [nzVisible]="openModal()"
  (nzOnCancel)="openModal.set(false)"
>
  <ng-container *nzModalContent>
    <form
      #form="ngForm"
      nz-form
      [formGroup]="reportIssueForm"
      (ngSubmit)="onReportIssueSubmit()"
    >
      <p>
        {{ 'shared.reportIssue.describeIssueMsg' | translate }}
      </p>

      <p>
        {{ 'shared.reportIssue.feedbackMsg' | translate }}
      </p>
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'global.description' | translate">
          <textarea
            rows="5"
            nz-input
            formControlName="issue"
            [placeholder]="'shared.reportIssue.placeholder' | translate"
          ></textarea>
        </nz-form-control>
      </nz-form-item>
      <p>
        <b>
          {{ 'shared.reportIssue.notificationMsg' | translate }}
        </b>
      </p>
    </form>
  </ng-container>

  <ng-container *nzModalFooter>
    <button nz-button nzType="primary" (click)="ngForm().ngSubmit.emit()">
      {{ 'shared.reportIssue.submitBtn' | translate }}
    </button>

    <button type="button" nz-button (click)="openModal.set(false)">
      {{ 'global.cancel' | translate }}
    </button>
  </ng-container>
</nz-modal>
